import ModuleHeader from "../components/ModuleHeader/ModuleHeader";
import usePrivateLink from "../config/usePrivateLink";

export default function MessLayout({ children }) {
  return ;
  const hasAccess = usePrivateLink();

  const tabs = [
    {
      id: "mess",
      title: "Mess",
      icon: "ri-hotel-line",
      path: "/mess/list",
    },
    {
      id: "messEnroll",
      title: "Enrolls",
      icon: "ri-settings-2-line",
      path: "/mess/enroll/list",
      activePaths: ["/mess/enroll/list", "/mess/enroll"],
    },
    {
      id: "attendanceMark",
      title: "Mark Attendance",
      icon: "ri-checkbox-circle-line",
      path: "/mess/attendance/mark",
    },
    {
      id: "attendance",
      title: "Attendance",
      icon: "ri-account-circle-line",
      path: "/mess/attendance/list",
    },
    {
      id: "attendanceLog",
      title: "Log",
      icon: "ri-history-line",
      path: "/mess/attendance/log",
    },
    {
      id: "attendanceSummary",
      title: "Monthly Summary",
      icon: "ri-file-chart-line",
      path: "/mess/attendance/summary",
    },
  ];

  const permittedTabs = tabs.filter((tab) => hasAccess(tab.path));

  return (
    <>
      <ModuleHeader tabs={permittedTabs} />
      {children}
    </>
  );
}